<template>
    <header class="header">
        <!-- PC 헤더 -->
        <div class="header-primary-container">
            <div class="header-primary">
                <div class="header-primary__contents">
                    <div class="header-primary__forward">
                        <div class="header-logo">
                            <h1>
                                <router-link to="/" title="홈으로 이동">
                                    <span class="blind">SBA 국제유통센터</span>
                                </router-link>
                            </h1>
                        </div>

                        <!-- 모바일 사이드바 토글 버튼 -->
                        <div class="mobile-menu">
                            <button type="button" aria-pressed="false" class="button">
                                <span></span>
                            </button>
                        </div>
                    </div>
                    <!-- <div class="header-search">
                        <form class="header-search__form">
                            <input v-model="searchValue" class="header-search__input" type="text" name="" value="" placeholder="검색어를 입력하세요" />
                            <button class="header-search__button" @click="search"></button>
                        </form>
                    </div> -->
                    <div class="header-primary__body">
                        <div class="header-primary__main">                        
                            <div class="header-primary__main-inner">
                                <ul class="header-menu-lists">
                                    <!--
                                        ※1뎁스 활성화시 a.link에 서브 클래스 추가
                                        서브 클래스명: link--on
                                    -->
                                    <li class="header-menu-list"><router-link to="/about" class="link"><h2>페이지소개</h2></router-link></li>
                                    <li class="header-menu-list"><router-link to="/fairs" class="link"><h2>매칭상담회</h2></router-link></li>
                                    <li class="header-menu-list"><router-link to="/center/faqs" class="link"><h2>자주 묻는 질문</h2></router-link></li>
                                    <li class="header-menu-list"><router-link to="/center/notice" class="link"><h2>공지사항</h2></router-link></li>
                                </ul>

                                <div class="header-primary-dimmed"></div>
                            </div>
                        </div>
                    </div>
                    <div class="header-primary__right">
                        <!-- <ul class="">
                            <li class="header-menu-list"><locale-select></locale-select></li>
                        </ul> -->
                        <ul class="header-customer-lists">
                            <li>
                                <gnb-login-button></gnb-login-button>
                            </li>
                            <li>
                                <router-link to="/mypage/myinfo"><span>마이페이지</span></router-link>
                            </li>
                        </ul>
                        <!-- <router-link to="/estimate/estimate-inquiry" class="header-primary__right-inquiry"><span class="blind">견적신청 1566-7777</span></router-link> -->
                    </div>
                </div>
            </div>
        </div>
        <!-- // PC 헤더 -->
        <!-- Mobile 헤더 -->
        <div class="mobile-sidebar">
            <div class="mobile-sidebar__head">
                <button class="mobile-sidebar__close" type="button"><span class="blind">모바일 메뉴바 닫기</span></button>
                <!-- <div class="mobile-sidebar-info">
                    <router-link class="member-name" to="/login">
                        <span>로그인 해주세요</span>
                        <span></span>
                    </router-link>
                </div> -->
                <locale-select></locale-select>
            </div>
            <div class="mobile-sidebar__body">
                <ul class="mobile-category__lists">
                    <li class="mobile-category__list" data-category-order>
                        <router-link to="/about" class="mobile-category__list-link"><span>페이지 소개</span></router-link>
                    </li>
                    <li class="mobile-category__list" data-category-order>
                        <router-link to="/fairs" class="mobile-category__list-link"><span>매칭상담회</span></router-link>
                    </li>
                    <li class="mobile-category__list" data-category-order>
                        <router-link to="/center/faqs" class="mobile-category__list-link"><span>자주 묻는 질문</span></router-link>
                    </li>
                    <li class="mobile-category__list" data-category-order>
                        <router-link to="/center/notice" class="mobile-category__list-link"><span>공지사항</span></router-link>
                    </li>
                </ul>
                <!-- <ul class="mobile-usermenu__lists">
                    <li class="mobile-usermenu__list"><router-link to="/center/notice" class="mobile-usermenu__list-link"><span>공지사항</span></router-link></li>
                    <li class="mobile-usermenu__list"><router-link to="/center/notice" class="mobile-usermenu__list-link"><span>공지사항</span></router-link></li>
                </ul> -->
            </div>
            <div class="mobile-sidebar__foot">
                <ul class="mobile-foot-link">
                    <li><gnb-login-button /></li>
                    <li><router-link to="/mypage/myinfo"><span>마이페이지</span></router-link></li>                    
                </ul>
            </div>
        </div>
        <div class="mobile-sidebar-dimmed"></div>
        <!-- // Mobile 헤더 -->
    </header>
</template>

<script>
import api from "@/api";
import { Header } from "@/plugins/header.js"; // Sticky & Heaer 스크립트
import gnbLoginButton from "@/components/client/login/gnb-login-button.vue";
import LocaleSelect from "@/components/client/inc/locale-select.vue";

export default {
    components: {
        gnbLoginButton,
        LocaleSelect
    },
    mounted() {
        this.header();
        window.scrollTo(0, 0); // 라우터 이동 시 스크롤 상단부터 시작
    },
    methods: {
        header: function() {
            this.$nextTick(function() {
                Header(); // Sticky & Heaer 스크립트 로드
            });
        },
    },
};
</script>